import React from "react"
import classNames from "classnames"

import styles from "./index.module.less"

interface IProps {
    data: {
        text: string
        color: boolean
        hideBackground?: boolean
    }[]
    className?: string
    style?: React.CSSProperties
}

const SectionTitle: React.FC<IProps> = (props) => {
    const { data, className, style } = props

    return (
        <div
            className={classNames(styles.sectionTitle, className)}
            style={style}
        >
            <div className={styles.text}>
                {data.map((item, index) => {
                    if (item.color) {
                        return (
                            <span
                                key={index}
                                className={classNames(
                                    styles.highlight,
                                    item.hideBackground && styles.hideBackground
                                )}
                            >
                                <span>{item.text}</span>
                            </span>
                        )
                    }

                    return <span key={index}>{item.text}</span>
                })}
            </div>
        </div>
    )
}

export default SectionTitle
